import type { RiderJobView, RiderNetworkAdmin, RidersPort, RiderStatusView, ShopRiderJob } from './ports.ts';
import type { WorkerClient } from './worker.ts';

export function createRiders(worker: WorkerClient): RidersPort {
  return {
    status: () => worker.call<RiderStatusView>('rider_status'),
    apply: input => worker.call<RiderStatusView>('rider_apply', input),
    setOnline: async online => { await worker.call('rider_set_online', { online }); },
    offers: async () => (await worker.call<{ offers: RiderJobView[] }>('rider_offers')).offers,
    accept: async orderId => { await worker.call('rider_accept', { orderId }); },
    decline: async orderId => { await worker.call('rider_decline', { orderId }); },
    job: orderId => worker.call<RiderJobView>('rider_job', { orderId }),
    pickup: (orderId, code) => worker.call<RiderJobView>('rider_pickup', { orderId, code }),
    location: async (orderId, point) => { await worker.call('rider_location', { orderId, point }); },
    deliver: async (orderId, code) => { await worker.call('rider_deliver', { orderId, code }); },
    payFee: (orderId, momo) => worker.call('rider_fee_pay', { orderId, ...momo }),
    feeOtp: async (orderId, otp) => { await worker.call('rider_fee_otp', { orderId, otp }); },
    feeStatus: orderId => worker.call('rider_fee_status', { orderId }),
    shopJob: async orderId => (await worker.call<{ job: ShopRiderJob | null }>('shop_rider_job', { orderId })).job,
    network: (input = {}) => worker.call<RiderNetworkAdmin>('admin_rider_network', input),
    review: async (uid, outcome, note) => { await worker.call('admin_review_rider', { uid, outcome, note }); },
    setNetwork: async (enabled, zones) => { await worker.call('admin_set_rider_network', { enabled, zones }); },
    setRiderStatus: async (uid, status) => { await worker.call('admin_set_rider_status', { uid, status }); },
    createPartner: input => worker.call<{ partnerId: string; secret: string }>('admin_create_partner', input),
  };
}
